export const JobPostingCompensationTypeLabelsLabelsMap = {
    hourly: 'applicant-tracker.compensationTypes.hourly',
    daily: 'applicant-tracker.compensationTypes.daily',
    weekly: 'applicant-tracker.compensationTypes.weekly',
    monthly: 'applicant-tracker.compensationTypes.monthly',
    yearly: 'applicant-tracker.compensationTypes.yearly',
} as const;
